import MyApplications from './MyApplications';
export { MyApplications };
export default MyApplications;
